import axiosInstance from 'api/axiosInstance';
import { stringify } from 'query-string';
import { Nullable } from 'types/global.types';
import type { LoginData } from 'types/login.types';
import type {
  EmailAvailabilityResponse,
  SearchResponse,
  SignupData,
} from 'types/signup.types';

export const searchEntrprises = (
  name?: string | Nullable<string>[],
  country?: string,
  VATNumber?: string,
): Promise<SearchResponse> => {
  return axiosInstance.get(
    'v2/users/search-enterprises?' +
      stringify({ name, country, VATNumber }, { arrayFormat: 'comma' }),
  );
};

export const checkEmailAvailability = (body: {
  email?: string;
  googleIdToken?: string;
  appleIdToken?: string;
}): Promise<EmailAvailabilityResponse> =>
  axiosInstance.get<any, EmailAvailabilityResponse>('v2/users/email-check', {
    params: body,
  });

export const signupUser = (
  data: SignupData & { invitation_token?: string },
): Promise<LoginData> => {
  return axiosInstance.post('v2/users', data);
};
